/** Shared react-select styles for light / dark dashboard theme. */
export const getReactSelectStyles = (isDark) => ({
  control: (base, state) => ({
    ...base,
    minHeight: 48,
    backgroundColor: isDark ? "#374151" : "#f3f4f6",
    borderColor: state.isFocused ? "#f97316" : isDark ? "#4b5563" : "#e5e7eb",
    boxShadow: state.isFocused ? "0 0 0 1px #f97316" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#f97316" : isDark ? "#6b7280" : "#d1d5db",
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: isDark ? "#374151" : "#ffffff",
    border: `1px solid ${isDark ? "#4b5563" : "#e5e7eb"}`,
    zIndex: 9999,
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: isDark ? "#374151" : "#ffffff",
    padding: 4,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#f97316"
      : state.isFocused
      ? isDark
        ? "#4b5563"
        : "#ffedd5"
      : isDark
      ? "#374151"
      : "#ffffff",
    color: state.isSelected ? "#ffffff" : isDark ? "#e5e7eb" : "#374151",
    cursor: "pointer",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: isDark ? "#4b5563" : "#e5e7eb",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: isDark ? "#f3f4f6" : "#374151",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: isDark ? "#f3f4f6" : "#374151",
    ":hover": {
      backgroundColor: "#ef4444",
      color: "#ffffff",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: isDark ? "#9ca3af" : "#6b7280",
  }),
  singleValue: (base) => ({
    ...base,
    color: isDark ? "#e5e7eb" : "#374151",
  }),
  input: (base) => ({
    ...base,
    color: isDark ? "#e5e7eb" : "#374151",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: isDark ? "#6b7280" : "#d1d5db",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: isDark ? "#9ca3af" : "#6b7280",
    ":hover": { color: isDark ? "#e5e7eb" : "#374151" },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: isDark ? "#9ca3af" : "#6b7280",
    ":hover": { color: isDark ? "#e5e7eb" : "#374151" },
  }),
});

export const reactSelectCommonProps = (isDark) => ({
  styles: getReactSelectStyles(isDark),
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "fixed",
});
